var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.InputField,{attrs:{"name":`property-${_vm.property.id}`,"label":_vm.property.label,"value":_vm.modelValue,"placeholder":_vm.$t('entity-item.enter-property-value'),"required":false,"errors":_vm.errors,"disabled":_vm.disabled},on:{"input":_setup.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }